import { UserEntity } from "@lifeat/shared/data-models/user/UserEntity";
import { useUserContext } from "@contexts/UserContext";

export default function useDoesUserHavePlannerAccess() {
    const { userData } = useUserContext();
    return doesUserHaveAccessToPlanner(userData);
}

const doesUserHaveAccessToPlanner = (userData: UserEntity | null | undefined): boolean => {
    return userData?.proUserInfo?.isProUser;
};
